import _ from 'lodash'
import { ValidityDeterminate } from '@fusion-advantage/backcompat'
import { OncologyReviewConcept, ExecutableCalc, CalcType, ExecutableCalcCalculateFunction, ExecutableCalcCalculateOk, CalcRuntimeError } from '@fusion-advantage/formlib'
import { createSelector } from '@reduxjs/toolkit'
import { FormRootState } from '../../redux/formStore'
import { ok, Result } from 'neverthrow'

//
//
// ONCOLOGY
//

export const createOncologyValidationCalc = (getState: () => FormRootState): ExecutableCalc => {
	const selectCalculateFn = createSelector(
		(state: FormRootState) => state.formModel.oncologyReview,
		(models): ExecutableCalcCalculateFunction => {
			return (ctx): Result<ExecutableCalcCalculateOk, CalcRuntimeError> => {
				const uniqueModels = new Set([...models.map(item => JSON.stringify(item))])
		
				if(_.filter(models, item => !item.tumor || !item.treatmentStatus).length > 0) {
					return ok({
						calcType: CalcType.Validation,
						returnValue: {
							determinate: ValidityDeterminate.Required,
							message: 'Primary tumor and treatment status required for each row',
						}
					})
				}

				if(_.filter(models, item => !!item.metastaticSite && !item.metastaticSiteStatus).length > 0) {
					return ok({
						calcType: CalcType.Validation,
						returnValue: {
							determinate: ValidityDeterminate.Required,
							message: 'Status of metastasis is required when a metastatic site is selected',
						}
					})
				}
		
				if (uniqueModels.size !== models.length) {
					return ok({
						calcType: CalcType.Validation, 
						returnValue: {
							determinate: ValidityDeterminate.Invalid,
							message: 'Duplicate entry in Oncology Review table',
						}
					})
				}
				
				return ok({ calcType: CalcType.Validation, returnValue: {
					determinate: ValidityDeterminate.Valid,
				}})
			}
		}
	)
	return new ExecutableCalc({
		calcType: CalcType.Validation,
		outputCid: OncologyReviewConcept.cid,
		inputCids: [OncologyReviewConcept.cid],
		selectCalculate: () => selectCalculateFn(getState())
	})
}